import api from 'src/Utils/api';
export var singIn = function (_a) {
    var email = _a.email, password = _a.password;
    return api.post('/admin_users/sign_in', {
        email: email,
        password: password,
    });
};
